import React from "react";
import { FormError } from "../../../../common/Input";

interface Props {
  register: any;
  errors: any;
  setValue: any;
  watch: any;
}

function Consentement({ register, errors, setValue, watch }: Props) {
  const accepted = watch ? watch("consentement") : false;

  return (
    <div className="form-register-tabs-component mt-5">
      <p className="custom_validate_cart_step__title">Consentement</p>

      <div className="infos_livraison_container pt-4">
        <p className="text-muted mb-4">
          Vos informations personnelles et médicales resteront strictement
          confidentielles et ne seront partagées qu'avec le praticien
          concerné.
        </p>

        <div className="col-md-9 mb-3">
          <label
            className={`btn form-control-register-tabs w-100 text-start d-flex justify-content-between align-items-center ${
              accepted ? "consentement-checked" : ""
            }`}
          >
            J'accepte les conditions générales et la politique de
            confidentialité
            <input
              type="checkbox"
              className="consentement-checkbox"
              checked={!!accepted}
              onChange={(e) => setValue("consentement", e.target.checked)}
            />
          </label>
          <FormError error={errors?.consentement?.message} />
        </div>
      </div>
    </div>
  );
}

export default Consentement;